import { render, staticRenderFns } from "./MobileLink.vue?vue&type=template&id=5354d71f&scoped=true"
import script from "./MobileLink.vue?vue&type=script&lang=js"
export * from "./MobileLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354d71f",
  null
  
)

export default component.exports